import * as React from 'react';
import cx from 'classnames';

import './checkbox.styles.scss';

const CHECKBOX_VALUE = {
  yes: 'true',
  no: 'false'
};

const VALUES_MAP = {
  [CHECKBOX_VALUE.no]: CHECKBOX_VALUE.yes,
  [CHECKBOX_VALUE.yes]: CHECKBOX_VALUE.no
};

export const Checkbox = (props) => {
  const { value, metadata, onSave, moduleName, className } = props;
  const possibleValues = Object.values(CHECKBOX_VALUE);
  const hasValidValue = possibleValues.includes(value);
  const normalizedValue = hasValidValue ? value : CHECKBOX_VALUE.no;

  const handleChange = React.useCallback((e) => {
    e.persist();

    const { value } = e.currentTarget.dataset;

    onSave({
      value,
      metadata,
    });
  }, [onSave, metadata]);

  return (
    <div className={cx("TableCheckbox", className)} data-value={VALUES_MAP[normalizedValue]} onClick={handleChange}>
      <input
        id={`${moduleName}-checkbox--filter`}
        type="checkbox"
        value={VALUES_MAP[normalizedValue]}
        checked={normalizedValue === CHECKBOX_VALUE.yes}
        readOnly
      />
    </div>
  );
};

Checkbox.defaultProps = {
  defaultValue: '',
};